import { defineStyleConfig } from '@chakra-ui/react';

export const CircularProgress = defineStyleConfig({
  baseStyle: {
    color: 'red.500',
  },
});
